import { Component, signal } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs';
import { Header } from './shared/components/header/header';
import { Footer } from './shared/components/footer/footer';
import { Toast } from 'primeng/toast';
import { environment } from '../environments/environment';
import { AuthService } from './shared/services/auth-service';
import { ProfileService } from './shared/services/profile-service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Header, Footer, Toast],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  isChromeless = signal(false);

  constructor(
    private authService: AuthService,
    private profileService: ProfileService,
    private router: Router
  ) {
    console.log(`App version : ${environment.version} running in ${environment.production?"Production":"Develpment"}`);
    if (this.authService.checkIsLoggedIn()) {
      this.profileService.getProfileData();
    }

    this.isChromeless.set(this.isChromelessUrl(this.router.url));
    this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe(e => this.isChromeless.set(this.isChromelessUrl(e.urlAfterRedirects)));
  }

  private isChromelessUrl(url: string): boolean {
    return url.startsWith('/external-assessment');
  }

}
